import React from "react";
import { components } from "react-select";

function isMultiValueChild(child) {
    if (!React.isValidElement(child)) {
        return false;
    }
    return child.type === components.MultiValue;
}

function withoutMultiValueChildren(children) {
    return React.Children.toArray(children).filter((child) => !isMultiValueChild(child));
}

export function HandleSelect(selected,value, setSelected, allOptions, withSelectAll){
    // console.log(JSON.stringify(selected)+"selected")
    // console.log(JSON.stringify(value)+"value")
    // console.log(JSON.stringify(setSelected)+"setSelected")
    // console.log(JSON.stringify(allOptions)+"allOptions")
    // console.log(JSON.stringify(withSelectAll)+"withSelectAll")
   
    // Determine the changed option (added or removed)
    const currentValue = Array.isArray(value) ? value : [];
    const changedOption = (selected || []).find((item) => !currentValue.includes(item));

    const selectAllOption = withSelectAll.find((item) => item.value === "select-all");

    if (changedOption !== undefined && changedOption.value === "select-all") {
        setSelected(selectAllOption ? [selectAllOption] : withSelectAll);
    }
    else {
        const areAllSelected = () => allOptions.every((option) =>
            selected ? selected.some((s) => s.value === option.value) : false,
        );

        const selectAllActive = (value || []).some((item) => item.value === "select-all");

        if (areAllSelected()) {
            if (changedOption === undefined && !selectAllActive) {
                setSelected([]);
            } else {
                setSelected(selectAllOption ? [selectAllOption] : withSelectAll);
            }
        }
        else if (selectAllActive) {
            if (!selected || selected.length === 0) {
                setSelected([]);
            } else {
                const withoutSelectAll = selected.filter((item) => item.value !== "select-all");
                setSelected(withoutSelectAll);
            }
        }
        else {
            const withoutSelectAll = selected.filter((item) => item.value !== "select-all");
            setSelected(withoutSelectAll);
        }
    }
};

// export function ValueContainer ({ children, ...props }){
// IMPORTANT NOTE: This code is working good but react-select won't close when clicking outside the react select dropdown
//     // Calculate the count of selected items using props
//     const selectedCount = props.getValue().length;
//     const withoutSelectAllLength = props.getValue().filter((item) => item.value !== 'select-all').length;
//     // Access the placeholder from selectProps
//     const placeholder = props.selectProps.placeholder;
//     return (
//       <components.ValueContainer {...props}>
//         {selectedCount === 0
//           ? placeholder
//           : selectedCount === props.options.length
//           ? `All selected (${withoutSelectAllLength})`
//           : `${selectedCount} selected`}
//       </components.ValueContainer>
//     );
// };

export function ValueContainer({ children, ...props }) {
    const { getValue, options } = props;
    const selected = getValue() || [];
    const withoutSelectAll = selected.filter((item) => item.value !== "select-all");
    const realOptions = (options || []).filter((item) => item.value !== "select-all");

    const selectAllActive = selected.some((item) => item.value === "select-all");
    const selectedCount = selectAllActive ? realOptions.length : withoutSelectAll.length;
    const hasSelection = selectAllActive || withoutSelectAll.length > 0;

    const isAllSelected = realOptions.length > 0 && (
        selectAllActive
        || withoutSelectAll.length === realOptions.length
    );

    const summary = !hasSelection
        ? null
        : isAllSelected
            ? `All selected (${selectedCount})`
            : `${selectedCount} selected`;

    const displayChildren = withoutMultiValueChildren(children);

    return (
        <components.ValueContainer {...props}>
            <div style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                height: 28,
                maxHeight: 28,
                flexWrap: "nowrap",
                overflow: "hidden",
            }}>
                {summary ? (
                    <span
                        style={{
                            fontWeight: "bold",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            flexShrink: 0,
                            maxWidth: "100%",
                            marginRight: 4,
                            fontSize: 13,
                        }}
                    >
                        {summary}
                    </span>
                ) : null}
                <div style={{
                    flex: hasSelection ? "0 1 24px" : "1 1 auto",
                    minWidth: hasSelection ? 24 : 0,
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "nowrap",
                }}>
                    {displayChildren}
                </div>
            </div>
        </components.ValueContainer>
    );
}

export function CompactMultiValue() {
    return null;
}

export function Option(props) {
    const { data, selectProps, isSelected, innerProps } = props;
    const selected = selectProps.value || [];
    const selectAllActive = selected.some((item) => item.value === "select-all");
    const realOptions = (selectProps.options || []).filter((item) => item.value !== "select-all");
    const checked = selectAllActive || isSelected;

    const handleMouseDown = (event) => {
        if (!selectAllActive) {
            innerProps?.onMouseDown?.(event);
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        if (data.value === "select-all") {
            selectProps.onChange([], { action: "deselect-option", option: data });
            return;
        }
        const remaining = realOptions.filter((option) => option.value !== data.value);
        selectProps.onChange(remaining, { action: "deselect-option", option: data });
    };

    return (
        <components.Option
            {...props}
            isSelected={checked}
            innerProps={{ ...innerProps, onMouseDown: handleMouseDown }}
        >
            <input type="checkbox" checked={checked} readOnly onChange={() => null} />
            <label>{data.label}</label>
        </components.Option>
    );
}

export const reportMultiSelectComponents = {
    Option,
    ValueContainer,
    MultiValue: CompactMultiValue,
};

export const multiSelectSearchStyles = {
    valueContainer: (base) => ({
        ...base,
        flexWrap: "nowrap",
        overflow: "hidden",
        maxHeight: 36,
        paddingTop: 2,
        paddingBottom: 2,
    }),
    multiValue: (base) => ({
        ...base,
        display: "none",
    }),
    input: (base) => ({
        ...base,
        minWidth: "24px",
        width: "100%",
        margin: 0,
        padding: 0,
    }),
    control: (base, state) => ({
        ...base,
        minHeight: 40,
        borderColor: state.isFocused ? "#2684ff" : base.borderColor,
        boxShadow: state.isFocused ? "0 0 0 1px #2684ff" : base.boxShadow,
        overflow: "hidden",
    }),
    menu: (base) => ({
        ...base,
        zIndex: 5,
    }),
};

export const reportFilterSelectStyles = {
    ...multiSelectSearchStyles,
    container: (base) => ({
        ...base,
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
    }),
    control: (base, state) => ({
        ...base,
        minHeight: 34,
        maxHeight: 34,
        fontSize: 12,
        borderColor: state.isFocused ? '#2A98D0' : '#c5d9ee',
        background: '#f8fbff',
        boxShadow: state.isFocused ? '0 0 0 1px #2A98D0' : base.boxShadow,
        overflow: 'hidden',
    }),
    valueContainer: (base) => ({
        ...multiSelectSearchStyles.valueContainer(base),
        maxHeight: 32,
        padding: '0 6px',
    }),
    menu: (base) => ({
        ...base,
        zIndex: 20,
        fontSize: 12,
    }),
    placeholder: (base) => ({
        ...base,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
    }),
};
